import { isError, isLoading, isNotLoaded, isReloading } from './helpers.js';
import { LoadingState, } from './types.js';
export const createNotLoaded = () => ({
    loadingState: LoadingState.NotLoaded,
});
export const createLoading = () => ({
    loadingState: LoadingState.Loading,
});
export const createReloading = (data) => ({
    loadingState: LoadingState.Reloading,
    data,
});
export const createLoaded = (data) => ({
    loadingState: LoadingState.Loaded,
    data,
});
export const createError = (error) => ({
    loadingState: LoadingState.Error,
    error,
});
export const createPartialLoading = (data) => ({
    loadingState: LoadingState.LoadingPartial,
    data,
});
export const createPartialError = (data, error) => ({
    loadingState: LoadingState.ErrorPartial,
    error,
    data,
});
export const mapLoadable = (source, data) => {
    if (isNotLoaded(source)) {
        return createNotLoaded();
    }
    if (isLoading(source)) {
        return createLoading();
    }
    if (isError(source)) {
        return createError(source.error);
    }
    if (isReloading(source)) {
        return createReloading(data);
    }
    return createLoaded(data);
};
//# sourceMappingURL=utils.js.map